<router-outlet></router-outlet>

<p-toast></p-toast>